module.exports = __webpack_public_path__ + "img/workshops_2.f14e1c0a.png";